<div id="commercial-contact-information-container">
  <form [formGroup]="form()!" id="commercial-contact-form">
    <div id="general-info">
      <p-panel
        header="{{ 'COMMERCIAL_SERVICES.LABEL.GENERAL_INFO' | translate }}"
        [toggleable]="true"
        toggler="header"
      >
        <div>
          <div class="row">
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.FIRST_NAME' | translate
                }}<span class="required">*</span>
              </div>
              <div class="row-input">
                <input type="text" pInputText formControlName="firstName" />
                <app-inline-validation
                  field="firstName"
                  [control]="form()!.controls['firstName']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.LAST_NAME' | translate
                }}<span class="required">*</span>
              </div>
              <div class="row-input">
                <input type="text" pInputText formControlName="lastName" />
                <app-inline-validation
                  field="lastName"
                  [control]="form()!.controls['lastName']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.COMPANY' | translate
                }}<span class="required">*</span>
              </div>
              <div class="row-input">
                <p-select
                  [options]="availableCompanies()"
                  formControlName="companyId"
                  [filter]="true"
                />
                <app-inline-validation
                  field="companyId"
                  [control]="form()!.controls['companyId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.ROLE' | translate
                }}<span class="required">*</span>
              </div>
              <div class="row-input">
                <p-select
                  [options]="availableJobRoles()"
                  formControlName="jobRoleId"
                  [filter]="true"
                />
                <app-inline-validation
                  field="jobRoleId"
                  [control]="form()!.controls['jobRoleId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.EMAIL' | translate
                }}<span class="required">*</span>
              </div>
              <div class="row-input">
                <input type="text" pInputText formControlName="emailAddress" />
                <app-inline-validation
                  field="emailAddress"
                  [control]="form()!.controls['emailAddress']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <div class="row-label commercial-contact-form-label">
                {{ 'COMMERCIAL_SERVICES.LABEL.ICE' | translate }}
              </div>
              <div class="row-input">
                <input type="text" pInputText formControlName="ice" />
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
    <br />
    <div id="phone-numbers">
      <p-panel
        header="{{ 'CONTACT.LABEL.PHONE_NUMBERS' | translate }}"
        [toggleable]="true"
        toggler="header"
      >
        <div class="row">
          <div class="row-item">
            <div class="row-label commercial-contact-form-label">
              {{ 'COMMERCIAL_SERVICES.LABEL.OFFICE_NUMBER' | translate }}
            </div>
            <div class="row-input">
              <p-inputMask
                [mask]="phoneMask"
                id="deskPhone"
                formControlName="deskPhone"
              />
              @if (contact()?.deskPhone && !form()!.dirty) {
                <a href="tel:9-{{ contact()!.deskPhone }}">
                  <button
                    type="button"
                    pButton
                    icon="fa fa-phone"
                    aria-label="Call office number"
                    pTooltip="Call {{ contact()!.deskPhone }}"
                    class="call-contact-btn"
                  ></button>
                </a>
              }
            </div>
          </div>

          <div class="row-item">
            <div class="row-label commercial-contact-form-label">
              {{ 'COMMERCIAL_SERVICES.LABEL.MOBILE_NUMBER' | translate }}
            </div>
            <div class="row-input">
              <p-inputMask
                [mask]="phoneMask"
                id="mobilePhone"
                formControlName="mobilePhone"
              />
              @if (contact()?.mobilePhone && !form()!.dirty) {
                <a href="tel:9-{{ contact()!.mobilePhone }}">
                  <button
                    type="button"
                    pButton
                    icon="fa fa-phone"
                    aria-label="Call mobile number"
                    pTooltip="Call {{ contact()!.mobilePhone }}"
                    class="call-contact-btn"
                  ></button>
                </a>
              }
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </form>
</div>
